import React from 'react';

const GameImagePlaceholder = ({ gameName, provider, width = 70, height = 40 }) => {
    // Генерируем цвет на основе названия игры
    const generateColor = (name) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = Math.abs(hash % 360);
        return `hsl(${hue}, 70%, 50%)`;
    };

    const backgroundColor = generateColor(gameName);

    // Берем первые две буквы названия игры
    const initials = gameName
        .split(' ')
        .map(word => word.charAt(0))
        .join('')
        .substring(0, 2)
        .toUpperCase();

    const styles = {
        container: {
            width: width,
            height: height,
            backgroundColor,
            display: 'flex',
            flexDirection: width > height ? 'row' : 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            color: 'white',
            fontWeight: 'bold',
            fontSize: height < 35 ? '10px' : '12px',
            textShadow: '0 1px 2px rgba(0,0,0,0.5)',
            background: `linear-gradient(135deg, ${backgroundColor}, ${backgroundColor}dd)`,
            border: '1px solid rgba(255,255,255,0.2)',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
        initials: {
            fontSize: height < 35 ? '10px' : '14px',
            fontWeight: 'bold',
            marginBottom: width > height ? '0' : '2px',
            marginRight: width > height ? '4px' : '0',
        },
        provider: {
            fontSize: height < 35 ? '6px' : '8px',
            opacity: 0.8,
            textAlign: 'center',
            lineHeight: '1',
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.initials}>{initials}</div>
            <div style={styles.provider}>{provider}</div>
        </div>
    );
};

export default GameImagePlaceholder; 